<template>
    <div>
        <div></div>

        <div class="top-left-menu">
            Top left
        </div>

        <div class="top-right-menu">
            Top right
        </div>

        <div class="bottom-left-menu">
            Bottom left
        </div>

        <div class="bottom-right-menu">
            Bottom right
        </div>

        <div class="left-menu">
            Left Menu
            <div class="store-manager">
                <button id="saveButton" @click="onSave()">Save</button>
                <button id="clearSaveButton" @click="onCleanStorage()">Clean Storage</button>
                <button id="dumpProjectButton" @click="onDumpProject()">Dump Project</button>
            </div>

            <ToolManager :project="project"></ToolManager>
        </div>

        <div class="right-menu">
            <LayerList :project="project"></LayerList>
        </div>

        <div class="main">
            <div class="central-stage">
                <canvas id="whiteboard" resize></canvas>
            </div>
        </div>
    </div>
</template>

<script>
    import paper from 'paper';
    import ToolManager from "./whiteboard/ToolManager";
    import LayerList from "./whiteboard/LayerList";
    import Project from "./whiteboard/project";

    export default {
        name: "WhiteBoard",

        components: {LayerList, ToolManager},

        data: function () {
            return {
                project: null
            };
        },

        created: function () {
            paper.install(window);
        },

        mounted: function () {
            paper.setup('whiteboard');

            this.project = new Project(JSON.parse(localStorage.getItem('project')));

            paper.project.activeLayer.onMouseUp = function (e) {
                //console.log(e.target);
                //console.log(e.currentTarget);
            };
        },

        methods: {
            onCleanStorage: function () {
                localStorage.removeItem('project')
            },

            onSave: function () {
                let p = JSON.stringify(this.project.toSerializable());

                localStorage.setItem('project', p);
            },

            onDumpProject: function () {
                console.log(paper.project.exportJSON());
            },
        }
    }
</script>


<style scoped lang="scss">
    canvas {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    .main {
        height: auto;
        overflow: hidden;
    }

    .top-left-menu {
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        height: 40px;
        margin: 10px;
        width: 40%;
        background-color: #dcdcdc;
    }

    .top-right-menu {
        z-index: 100;
        position: absolute;
        top: 0;
        right: 0;
        height: 40px;
        margin: 10px;
        width: 40%;
        background-color: #dcdcdc;
    }

    .bottom-left-menu {
        z-index: 100;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 40px;
        margin: 10px;
        width: 40%;
        background-color: #dcdcdc;
    }

    .bottom-right-menu {
        z-index: 100;
        position: absolute;
        bottom: 0;
        right: 0;
        height: 40px;
        margin: 10px;
        width: 40%;
        background-color: #dcdcdc;
    }

    .left-menu {
        z-index: 100;
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        margin: auto 10px auto 10px;
        width: 200px;
        height: 60%;
        background-color: #dcdcdc;
    }

    .right-menu {
        z-index: 100;
        position: absolute;
        right: 0;
        top: 50%;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        margin: auto 10px auto 10px;
        width: 200px;
        height: 60%;
        background-color: #dcdcdc;
    }

    .store-manager {
        margin: 20px 0 20px 0;
    }
</style>
